module.exports = __webpack_public_path__ + "static/img/86-3.228e34d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/86-3.jpg
// module id = nX4U
// module chunks = 0